import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';
import { LocalAccountService } from '../shared/services/localAccount.service';

@Injectable({
  providedIn: 'root'
})
export class StudyPlanService implements Resolve<any> {

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if ((state.url.includes('common-area') && state.url.includes('subscription/') && state.url.includes('/detail')) ||
      (state.url.includes('administration-area') && state.url.includes('subjects/') && state.url.includes('/subscription/'))
    ) {
      try {
        const resolved: any = {};
        let subscriptionResponse: any;
        if (this.localAccountService.isAdmin() || this.localAccountService.isOperator()) {
          subscriptionResponse = await this.getSubscription(route.params.subscriptionId);
        } else {
          subscriptionResponse = await this.getSubscriptionAllowed(route.params.subscriptionId);
        }
        resolved.subscription = subscriptionResponse.payload;
        if (route.params.subjectId) {
          const subjectResponse: any = await this.getSubject(route.params.subjectId);
          resolved.subject = subjectResponse.payload;
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else {
      try {
        const resolved: any = {};
        if (route.params.degreeCourseId === 'new') {
          return resolved;
        } else {
          const degreeCourseResponse: any = await this.getDegreeCourse(route.params.degreeCourseId);
          resolved.degreeCourse = degreeCourseResponse.payload;
          if (route.params.subjectId && !(route.params.subjectId === 'new')) {
            const subjectResponse: any = await this.getSubject(route.params.subjectId);
            resolved.subject = subjectResponse.payload;
          }
          return resolved;
        }
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }
  }

  constructor(
    private api: ApiService,
    private router: Router,
    private localAccountService: LocalAccountService
  ) {

  }


  async newDegreeCourse(obj) {
    return this.api.postRequestPromise(`degreecourse/createDegreeCourse`, obj);
  }

  async editDegreeCourse(obj) {
    return this.api.putRequestPromise(`degreecourse/updateDegreeCourse`, obj);
  }

  async deleteDegreeCourse(degreeCourseId) {
    return this.api.deleteRequestPromise(`degreecourses/${degreeCourseId}`);
  }

  async getDegreeCourse(degreeCourseId) {
    return this.api.getRequestPromise(`degreecourses/${degreeCourseId}`);
  }

  async getAllDegreeCourses() {
    return this.api.getRequestPromise(`degreecourses/all`);
  }

  async reactivateDegreeCourse(degreeCourseId) {
    return this.api.putRequestPromise(`degreecourses/${degreeCourseId}/reactivate`, {});
  }

  async newSubject(obj) {
    return this.api.postRequestPromise(`subject/createSubject`, obj);
  }

  async editSubject(obj) {
    return this.api.putRequestPromise(`subject/updateSubject`, obj);
  }

  async deleteSubject(subjectId) {
    return this.api.deleteRequestPromise(`subjects/${subjectId}`);
  }

  async getSubject(subjectId) {
    return this.api.getRequestPromise(`subjects/${subjectId}`);
  }

  async getSubscription(subscriptionId) {
    return this.api.getRequestPromise(`subscriptions/${subscriptionId}`);
  }

  async getAllSubjectsByDegreeCourseId(degreeCourseId) {
    return this.api.getRequestPromise(`subjects/allByDegreeCourse?degreeCourseId=${degreeCourseId}`);
  }

  async reactivateSubject(subjectId) {
    return this.api.putRequestPromise(`subjects/${subjectId}/reactivate`, {});
  }

  async getAllSubscriptionsBySubject(subjectId) {
    return this.api.getRequestPromise(`subscriptions/allSubscriptionBySubject?subjectId=${subjectId}`);
  }

  async deactivateSubscription(subscriptionId) {
    return this.api.putRequestPromise(`subscriptions/${subscriptionId}/deactivate`, {});
  }

  async reactivateSubscription(subscriptionId) {
    return this.api.putRequestPromise(`subscriptions/${subscriptionId}/reactivate`, {});
  }

  async editSubscription(obj) {
    return this.api.putRequestPromise(`subscription/updateSubscription`, obj);
  }

  async getAllowedDegreeCourses() {
    return this.api.getRequestPromise(`public/degreecourses`);
  }

  async getAllowedSubjectsByDegreeCourseId(degreeCourseId) {
    return this.api.getRequestPromise(`public/subjects?degreeCourseId=${degreeCourseId}`);
  }

  async getAllowedSubscriptionsBySubject(subjectId) {
    return this.api.getRequestPromise(`public/subscriptions?subjectId=${subjectId}`);
  }

  async getSubscriptionAllowed(subscriptionId) {
    return this.api.getRequestPromise(`public/subscriptions/${subscriptionId}`);
  }

}
